<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Host Details</h5>
            </div>
            <div class="card">
                <div class="p-d-flex p-ai-center p-flex-column p-flex-lg-row p-mb-1">
                    <div class="p-d-flex p-mr-3">
                        <Dropdown v-model="emp_name" :options="adminList" @change="getHostDetails($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select admin"
                            :style="{ minWidth: '200px' }" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <TabView v-if="userdatadisplayflag" @tab-change="getTabChangeSettings">
        <TabPanel header="Active Hosts">
            <div class="card">
                <DataTable :value="EmpDetailsList" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="EmpTotalRecords" :loading="loading" @page="onPageChange(1, data)"
                    class="p-datatable-users" data-key="ac1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    :style="{ 'overflow-wrap': 'break-word' }">
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>

                    <Column header="Host Name" headerStyle="width: 30%">
                        <template #body="{ data }">
                            <div class="p-d-flex p-ai-center">
                                <div class="p-mr-3">
                                    <span v-if="data.ac18 != null && data.ac18 != ''">
                                        <img :src="'https://storage.googleapis.com/' + storage_path + '/hosts/Logo/' + data.ac18"
                                            height="50" width="50"
                                            style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                    <span v-if="!data.ac18">
                                        <img :src="'/assets/layout/images/default_hotel.jpeg'" height="50" width="50"
                                            style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                </div>
                                <div>
                                    <div class="p-text-capitalize">
                                        <span>{{ data.ac3 ? data.ac3 : "-" }}</span>
                                    </div>
                                    <small class="muted-text p-text-capitalize p-d-flex p-my-1">
                                        <span v-tooltip.right="'Date'">
                                            {{ data.z501 ? format_timestamp(data.z501) : "-" }}
                                        </span>
                                    </small>
                                </div>
                            </div>

                        </template>
                    </Column>
                    <Column header="Contact Person" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span class="p-text-capitalize">{{ data.ac6 ? data.ac6 : "-" }}</span>
                            <small class="muted-text p-text-capitalize p-d-flex p-my-1">
                                <span v-tooltip.right="'Designation'">
                                    {{ data.ac9 ? data.ac9 : "-" }}
                                </span>
                            </small>
                        </template>
                    </Column>

                    <!-- <Column header="Contact Number" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span>{{ data.ac7 ? data.ac7 : "-" }}</span>
                        </template>
                    </Column> -->
                    <Column header="No Of Branches" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span>{{ data.branchCount ? data.branchCount : "-" }}</span>
                        </template>
                    </Column>
                    <Column header="Address" headerStyle="width: 25%">
                        <template #body="{ data }">
                            <span class="p-text-capitalize">{{ data.ac21 ? data.ac21 : "-" }}</span>
                        </template>
                    </Column>

                    <Column header="Action" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <Button icon="pi pi-user" v-tooltip.left="'Login As Host'" severity="info"
                                class="p-button-rounded p-button-info" @click="loginAsHostDialogOpen(data)" />
                            <Button icon="pi pi-eye" class="p-button-rounded p-button-success p-ml-1"
                                @click="editHostDetailsRedirect(data)" />
                        </template>
                    </Column>
                </DataTable>
                <Toast />
            </div>
        </TabPanel>
        <TabPanel header="Temporarily Supsended Hosts">
            <div class="card">
                <DataTable :value="EmpDetailsList" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="EmpTotalRecords" :loading="loading" @page="onPageChange(2,data)" class="p-datatable-users"
                    data-key="ac1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    :style="{ 'overflow-wrap': 'break-word' }">
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>

                    <Column header="Host Name" headerStyle="width: 30%">
                        <template #body="{ data }">
                            <div class="p-d-flex p-ai-center">
                                <div class="p-mr-3">
                                    <span v-if="data.ac18 != null && data.ac18 != ''">
                                        <img :src="'https://storage.googleapis.com/' + storage_path + '/hosts/Logo/' + data.ac18"
                                            height="50" width="50"
                                            style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                    <span v-if="!data.ac18">
                                        <img :src="'/assets/layout/images/default_hotel.jpeg'" height="50" width="50"
                                            style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                </div>
                                <div>
                                    <div class="p-text-capitalize">
                                        <span>{{ data.ac3 ? data.ac3 : "-" }}</span>
                                    </div>
                                    <small class="muted-text p-text-capitalize p-d-flex p-my-1">
                                        <span v-tooltip.right="'Date'">
                                            {{ data.z501 ? format_timestamp(data.z501) : "-" }}
                                        </span>
                                    </small>
                                </div>
                            </div>

                        </template>
                    </Column>
                    <Column header="Contact Person" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span class="p-text-capitalize">{{ data.ac6 ? data.ac6 : "-" }}</span>
                            <small class="muted-text p-text-capitalize p-d-flex p-my-1">
                                <span v-tooltip.right="'Designation'">
                                    {{ data.ac9 ? data.ac9 : "-" }}
                                </span>
                            </small>
                        </template>
                    </Column>

                    <!-- <Column header="Contact Number" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span>{{ data.ac7 ? data.ac7 : "-" }}</span>
                        </template>
                    </Column> -->
                    <Column header="No Of Branches" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span>{{ data.branchCount ? data.branchCount : "-" }}</span>
                        </template>
                    </Column>
                    <Column header="Address" headerStyle="width: 25%">
                        <template #body="{ data }">
                            <span class="p-text-capitalize">{{ data.ac21 ? data.ac21 : "-" }}</span>
                        </template>
                    </Column>

                    <!-- <Column header="Action" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <Button icon="pi pi-user" v-tooltip.left="'Login As Host'" severity="info"
                                class="p-button-rounded p-button-info" @click="loginAsHostDialogOpen(data)" />
                            <Button icon="pi pi-eye" class="p-button-rounded p-button-success p-ml-1"
                                @click="editHostDetailsRedirect(data)" />
                        </template>
                    </Column> -->
                </DataTable>
                <Toast />
            </div>
        </TabPanel>
        <TabPanel header="Permanently Supsended Hosts">
            <div class="card">
                <DataTable :value="EmpDetailsList" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="EmpTotalRecords" :loading="loading" @page="onPageChange(3, data)"
                    class="p-datatable-users" data-key="ac1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    :style="{ 'overflow-wrap': 'break-word' }">
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>

                    <Column header="Host Name" headerStyle="width: 30%">
                        <template #body="{ data }">
                            <div class="p-d-flex p-ai-center">
                                <div class="p-mr-3">
                                    <span v-if="data.ac18 != null && data.ac18 != ''">
                                        <img :src="'https://storage.googleapis.com/' + storage_path + '/hosts/Logo/' + data.ac18"
                                            height="50" width="50"
                                            style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                    <span v-if="!data.ac18">
                                        <img :src="'/assets/layout/images/default_hotel.jpeg'" height="50" width="50"
                                            style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                </div>
                                <div>
                                    <div class="p-text-capitalize">
                                        <span>{{ data.ac3 ? data.ac3 : "-" }}</span>
                                    </div>
                                    <small class="muted-text p-text-capitalize p-d-flex p-my-1">
                                        <span v-tooltip.right="'Date'">
                                            {{ data.z501 ? format_timestamp(data.z501) : "-" }}
                                        </span>
                                    </small>
                                </div>
                            </div>

                        </template>
                    </Column>
                    <Column header="Contact Person" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span class="p-text-capitalize">{{ data.ac6 ? data.ac6 : "-" }}</span>
                            <small class="muted-text p-text-capitalize p-d-flex p-my-1">
                                <span v-tooltip.right="'Designation'">
                                    {{ data.ac9 ? data.ac9 : "-" }}
                                </span>
                            </small>
                        </template>
                    </Column>

                    <!-- <Column header="Contact Number" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span>{{ data.ac7 ? data.ac7 : "-" }}</span>
                        </template>
                    </Column> -->
                    <Column header="No Of Branches" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span>{{ data.branchCount ? data.branchCount : "-" }}</span>
                        </template>
                    </Column>
                    <Column header="Address" headerStyle="width: 25%">
                        <template #body="{ data }">
                            <span class="p-text-capitalize">{{ data.ac21 ? data.ac21 : "-" }}</span>
                        </template>
                    </Column>

                    <!-- <Column header="Action" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <Button icon="pi pi-user" v-tooltip.left="'Login As Host'" severity="info"
                                class="p-button-rounded p-button-info" @click="loginAsHostDialogOpen(data)" />
                            <Button icon="pi pi-eye" class="p-button-rounded p-button-success p-ml-1"
                                @click="editHostDetailsRedirect(data)" />
                        </template>
                    </Column> -->
                </DataTable>
                <Toast />
            </div>
        </TabPanel>
    </TabView>
    <!--Login as admin Dialog starts here -->
    <Dialog v-model:visible="loginAsHostDialogStatus" :style="{ width: '70vw' }" modal class="p-fluid"
        header="Host Login">
        <div style="position: relative;" v-if="!showLoader">
            <div class="p-pt-2 p-px-5">
                <div class="p-flpartyuid p-formgrid p-grid">
                    <div class="p-d-flex p-field p-col-6 p-md-12">
                        <h6 class="p-m-0 ">Select User:</h6>
                        <Dropdown id="select-user" class="p-ml-5 p-text-capitalize" v-model="hostUsers"
                            :options="hostUserlist" optionLabel="label" placeholder="Select User"
                            emptyMessage="No Records" appendTo="body" style="width: 30vw" />
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button v-if="!showLoader" :disabled="hostUsers == ''" label="Login" icon="pi pi-check"
                class="p-button-text p-ml-auto" style="width: 90px;" @click="loginAsHostRequest"></Button>
            <Button v-show="showLoader" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                style="width: 90px"></Button>
        </template>
    </Dialog>

    <!-- Login as admin Dialog end here -->
</template>
<script>
import ApiService from '../../service/ApiService';
import router from '@/router';
import useValidate from '@vuelidate/core';
import moment from 'moment';

export default {
    data() {
        return {
            v$: useValidate(),
            adminList: [],
            hostList: [],
            branchList: [],
            page_no: 0,
            EmpTotalRecords: 0,
            loading: false,
            EmpDetailsList: [],
            emp_name: '',
            host_name: '',
            branch_name: '',
            userdatadisplayflag: false,
            admin_id: '',
            host_id: '',
            admin_list_status: false,
            host_list_status: false,
            branch_list_status: false,
            itemsPerPage: 30,
            hostUserlist: [],
            loginAsHostDialogStatus: false,
            hostUsers: [],
            showLoader: false,
            status: 1,

        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    mounted() {
        this.storage_path = JSON.parse(localStorage.masterBucketName);
        if (this.$store.state.adminId != null) {
            this.admin_id = this.$store.state.adminId;
            let adminId = this.$store.state.adminId;
            this.ApiService.getAdminListOnly().then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    let emp_name_id = data.data.records.filter(function (item) {
                        return item.value == adminId;
                    });
                    if (emp_name_id.length > 0) {
                        this.emp_name = emp_name_id[0];
                    }
                    this.getHostDetails();
                } else {
                    this.adminList = null;
                }
            });
        } else {
            this.getAdminListOnly();
        }
    },

    methods: {
        getTabChangeSettings(e) {
            if (e.index == 0) {
                this.status = 1;
                this.getHostDetails();
            } else if (e.index == 1) {
                this.status = 2;
                this.getHostDetails();
            } else if (e.index == 2) {
                this.status = 3;
                this.getHostDetails();
            } else {
                this.status = 1;
                this.getHostDetails();
            }
        },

        editHostDetailsRedirect(data) {
            router.push({
                name: "hostDetails",
                params: { hostId: data.ac1, clientId: this.admin_id },
            });
            this.$store.dispatch("updateHostRedirectStatus", this.admin_id);
        },
        getAdminListOnly(e) {
            this.ApiService.getAdminListOnly(e).then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    if (data.data.records.length == 1) {
                        this.getHostDetails({ value: data.data.records[0] });
                        this.emp_name = data.data.records[0];
                    }
                } else {
                    this.adminList = null;
                }
            });
        },
        getHostUsersListOnly(e) {
            this.ApiService.getHostUsersListOnly(e).then((data) => {
                if (data.status == 200) {
                    this.hostUserlist = data.data.records;
                } else {
                    this.hostUserlist = null;
                }
            });
        },
        getHostDetails(e) {
            this.userdatadisplayflag = true;
            this.loading = true;
            if (e) {
                this.admin_id = e.value.value;
            }
            this.ApiService.getHostDetails({ clientId: this.admin_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage, status: this.status }).then((data) => {
                if (data.success === true) {
                    this.EmpDetailsList = data.data.result;
                    this.EmpTotalRecords = data.data.count;
                    this.loading = false;
                    this.admin_list_status = true;
                    this.host_name = '';
                    this.branch_name = '';
                    if (e) {
                        this.getHostListOnly(e);
                    }
                }
            });
        },
        onPageChange(status, e) {
            this.loading = true;
            this.status = status;
            if (this.admin_list_status) {
                this.page_no = e.page;
                this.getHostDetails();
            }
        },
        getHostListOnly(e) {
            this.ApiService.getHostListOnly({ clientId: e.value.value }).then((data) => {
                if (data.status == 200) {
                    this.hostList = data.data.records;
                } else {
                    this.hostList = null;
                }
            });
        },
        loginAsHostDialogOpen(data) {
            this.host_id = data.ac1;
            this.getHostUsersListOnly({ hostId: this.host_id, clientId: this.admin_id });
            this.submitted = false;
            this.loginAsHostDialogStatus = true;
            // this.v$.$reset();
        },
        format_timestamp(value) {
            if (value) {
                var localTime = new Date(value * 1000).toUTCString();
                return moment(localTime).format("DD/MM/YYYY @ hh:mm A");
            } else {
                return 'N/A';
            }
        },
        loginAsHostRequest() {
            this.id = this.host_id;
            this.isSubmitted = true;
            this.v$.$validate();
            var fields = {};
            fields['adminId'] = this.admin_id;
            fields["hostId"] = this.host_id;
            fields["userId"] = this.hostUsers.value;
            fields["userlabel"] = this.hostUsers.label;

            this.ApiService.getLoginAsHost(fields).then((items) => {
                if (items.status == 200) {
                    this.showLoader = false;
                    var successMsg = items.message;
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                }
            });
        },
    },
};
</script>
<style scoped lang="scss"></style>
